import React, { Component } from "react";
import "./notFound.scss";

class NotFound extends Component {
  render() {
    return (
      <div className="recover-box">
        <h2>page not Found</h2>
      </div>
    );
  }
}
export default NotFound;
